import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import FormInput from './fields/input-field';
import Button from '../button';
import {validateRequiredFields} from '../../utils/form';


class LoginForm extends React.Component {

    static propTypes = {
        onSubmit: PropTypes.func.isRequired
    };

    render() {
        const {error, handleSubmit, submitting} = this.props;
        return (
            <form onSubmit={handleSubmit(this.props.onSubmit.bind(this))} className="form">
                {error && <div className="global-error">{error}</div>}
                <div className="login-form">
                    <Field name="username" component={FormInput} label={'Vartotojo vardas'} type="text"
                           required={true}/>
                    <Field name="password" component={FormInput} label={'Slaptažodis'} type="password"
                           required={true}/>
                </div>
                <div className="row centered form-actions">
                    <Button submit={true} loading={submitting} disabled={submitting} type="form-signup">
                        Prisijungti
                    </Button>
                </div>
            </form>
        );
    }
}

const validate = values => {
    let errors = {};
    errors = validateRequiredFields(values, [
        'username', 'password'
    ], errors);

    return errors;
};

LoginForm = reduxForm({
    form: 'login_form',
    validate
})(LoginForm);
export default LoginForm;



// WEBPACK FOOTER //
// ./src/js/components/form/login-form.jsx